export default {
  home: 'Home',
  about: 'About Us',
  contact: 'Contact Us',
  login: 'Login',
  logout: 'Logout',
  switchLang: 'Switch Language',
  welcome: 'Welcome to our official website',
}
